import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Button, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  viewSummaryButton: {
    marginTop: theme.spacing(1),
    marginLeft: theme.spacing(-1)
  }
}));

export const ViewSummaryButton = ({ onClick }) => {
  const classes = useStyles();

  return (
    <Button
      color="primary"
      onClick={onClick}
      className={classes.viewSummaryButton}
      data-qe-id="ProjectCostOverridesViewSummary"
    >
      <FormattedMessage id="projectCostOverrides.summary.viewSummary" />
    </Button>
  );
};

ViewSummaryButton.propTypes = {
  onClick: PropTypes.func.isRequired
};

export default ViewSummaryButton;
